/**
 * Canonical spacing and layout token definitions for the Perplexity Design System.
 *
 * This file is the single source of truth for token values used by both
 * Aether primitive components and the Tailwind safelist configuration.
 *
 * In the future, this file will be generated by the design system pipeline.
 */
/** Spacing scale tokens used for padding, margin, and gap. */
export const SPACING_TOKENS = ['2xs', 'xs', 'sm', 'md', 'ml', 'lg', 'xl'];
/** Numeric Tailwind utilities emitted by the Aether spacing prop mappings. */
export const SPACING_UTILITY_TOKENS = ['0.5', '1', '2', '4', '6', '8', '12'];
/** Border radius tokens. */
export const ROUNDED_TOKENS = ['none', 'sm', 'md', 'lg', 'xl', '2xl', '3xl', 'full'];
/** Display mode tokens. Includes 'hidden' for the Tailwind `hidden` (display:none) utility. */
// prettier-ignore
export const DISPLAY_TOKENS = ['flex', 'block', 'inline-block', 'inline-flex', 'grid', 'hidden'];
/**
 * Breakpoints with full responsive support in Aether primitives.
 * 'default' is always implied and does not need to be listed here.
 * These are the additional Tailwind breakpoints that have safelist coverage.
 *
 * To add a new breakpoint (e.g. 'lg'):
 * 1. Add it to this array
 * 2. TS will guide remaining type fixes in Aether components
 * 3. The Tailwind safelist auto-generates the needed responsive classes
 */
export const REGISTERED_BREAKPOINTS = ['sm', 'md', 'lg', 'xl', '2xl'];
//# sourceMappingURL=spacingTokens.js.map